const heroData = {
  title: `Hi! I'm Kendall.`,
  message: `I'm a senior fullstack developer who helps build responsive, scalable
  applications focusing on code simplicity and straight forward solutions so
  companies can bring their ideas to market faster.`,
}

export default heroData
